export function LimitNameToOneLine(name: string) {
    const lines = name.split(`\n`);

    if (lines.length <= 1) {
        return name;
    }

    return lines[0] + "...";
}
